import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';

const STORAGE_KEY = 'portfolio-lang';

const savedLang = localStorage.getItem(STORAGE_KEY);
const initialLang = savedLang === 'ar' || savedLang === 'en' ? savedLang : 'en';

const applyDocumentLanguage = (lng) => {
  const code = lng?.startsWith('ar') ? 'ar' : 'en';
  document.documentElement.lang = code;
  document.documentElement.dir = 'ltr';
};

applyDocumentLanguage(initialLang);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLang,
  fallbackLng: 'en',
  supportedLngs: ['en', 'ar'],
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  const code = lng?.startsWith('ar') ? 'ar' : 'en';
  localStorage.setItem(STORAGE_KEY, code);
  applyDocumentLanguage(code);
});

export default i18n;
